import { render, staticRenderFns } from "./home.vue?vue&type=template&id=c2250baa&scoped=true&"
import script from "./home.vue?vue&type=script&lang=ts&"
export * from "./home.vue?vue&type=script&lang=ts&"
import style0 from "./home.vue?vue&type=style&index=0&id=c2250baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2250baa",
  null
  
)

export default component.exports